import React from "react";

export const Location = () => {
  return (
    <div style={{ marginTop: "60px" }}>
      <h1>Location </h1>
      <div>
        <div>12 Birkdale Street Colebee</div>
      </div>
      <br />
      <div>Classes are conducted at 12 Birkdale Street Colebee.</div>
      <div style={{ minHeight: "150px" }}></div>
    </div>
  );
};

export default Location;
